import { render, staticRenderFns } from "./StSocialMediaButtons.vue?vue&type=template&id=736eff30"
import script from "./StSocialMediaButtons.vue?vue&type=script&lang=ts"
export * from "./StSocialMediaButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports